export default {
	cod: null,
	razao_social: '',
	tipo: 'filial',
	logradouro: '',
	bairro: '',
	cidade: '',
	cep: '',
	estado: 'RJ',
	cnpj: '',
	ie: '',
	cnae: '',
	tel1: '',
	tel2: '',
	cel: '',
	nextel: '',
	email: '',
	procurador: '',
	cpf: '',
	rg: '',
	estado_civil: 'casado',
	obs: '',
};



// WEBPACK FOOTER //
// ./src/components/cadastros/managers/reset.js